import React, { useEffect, useState } from "react"
import { Button, Col, Form, FormGroup, Input, Label, Row } from "reactstrap"
import Application from "services/applications/Application.service"

let officerInfo = JSON.parse(localStorage.getItem("authUser"))
let appService = new Application(officerInfo)

const ApplicationFilter = props => {
  const [filterValues, setFilterValues] = useState({
    search: "",
    application_status: "",
    date_from: "",
    date_to: "",
    company_id:props.company_id,
    service_name: "",
  })
  const [applicationServices, setapplicationServices] = useState([])

  useEffect(()=>{
    fetchServices()
  }, [])

  const fetchServices = () => {
    appService.getAllServices().then(response => {
      // console.log("services", response.data)

      if (response.status) {
        const options = response.data.data.map(item =>  {
          return <option value={item.name}>{item.name}</option>
          
        })
        setapplicationServices(options)
      }
    })
  }

  const handleSubmit = e => {
    e.preventDefault()
    // Access filter values from filterValues object
    // Perform filtering or searching logic here
    props.handleSearch(filterValues)
  }

  const clearFields = () => {
    props.turnOffSearch()
    setFilterValues({
      search: "",
      application_status: "",
      date_from: "",
      date_to: "",
      service_name: "",
    })
  }

  return (
    <>
      <hr></hr>
      <Row>
      <Col md={3}>
          <FormGroup>
            <Label for="serviceName">
              Service Type:
            </Label>
            <Input
              type="select"
              name="serviceName"
              id="serviceName"
              value={filterValues.service_name}
              onChange={e =>
                setFilterValues({
                  ...filterValues,
                  service_name: e.target.value,
                })
              }
            >
              <option>----Select Service Type----</option>
              {applicationServices}
              </Input>
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label for="applicationId">
              Application ID/Applicant Name/Company:
            </Label>
            <Input
              type="text"
              name="applicationId"
              id="applicationId"
              value={filterValues.search}
              onChange={e =>
                setFilterValues({
                  ...filterValues,
                  search: e.target.value,
                })
              }
            />
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label for="dateFrom">Date From:</Label>
            <Input
              type="date"
              name="dateFrom"
              id="dateFrom"
              value={filterValues.date_from}
              onChange={e =>
                setFilterValues({ ...filterValues, date_from: e.target.value })
              }
            />
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label for="dateTo">Date To:</Label>
            <Input
              type="date"
              name="dateTo"
              id="dateTo"
              value={filterValues.date_to}
              onChange={e =>
                setFilterValues({ ...filterValues, date_to: e.target.value })
              }
            />
          </FormGroup>
        </Col>
        {props.allApplications ? (
          <Col md={3}>
            <FormGroup>
              <Label for="sortBy">Application Status:</Label>
              <Input
                type="select"
                name="sortBy"
                id="sortBy"
                value={filterValues.application_status}
                onChange={e =>
                  setFilterValues({
                    ...filterValues,
                    application_status: e.target.value,
                  })
                }
              >
                <option value="">Select...</option>
                <option value="SUBMITTED">SUBMITTED</option>
                <option value="UNDER REVIEW">UNDER REVIEW</option>
                <option value="REVIEWED">REVIEWED</option>
                <option value="DEPARTMENT APPROVED">DEPARTMENT APPROVED</option>
                <option value="DG APPROVED">DG APPROVED</option>
              </Input>
            </FormGroup>
          </Col>
        ) : null}
      </Row>
      <Row>
        <Col md={6}>
          <FormGroup>
            {/* <Label for="filterBtn">Filter:</Label> */}
            <br></br>
            <Button onClick={clearFields} color="info">
              Reset
            </Button>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            {/* <Label for="filterBtn">Filter:</Label> */}
            <br></br>
            <Button id="filterBtn" color="primary" onClick={handleSubmit}>
              Search
            </Button>
          </FormGroup>
        </Col>
      </Row>
      <hr></hr>
    </>
  )
}

export default ApplicationFilter
